export default {
    // 小程序模板列表
    list: {
        method: 'get',
        url: '/ant_mini_program_templates'
    },
    // 小程序模板使用统计
    statistics: {
        method: 'get',
        url: '/ant_mini_program_templates/:id/statistics'
    },
    // 小程序模板发布版本列表
    releasesList: {
        method: 'get',
        url: '/ant_mini_program_templates/:id/ant_mini_program_template_releases'
    },
    // 小程序模板发布版本新增
    addReleases: {
        method: 'post',
        url: '/ant_mini_program_templates/:id/ant_mini_program_template_releases'
    },
    // 小程序模板发布版本编辑
    editReleases: {
        method: 'patch',
        url: '/ant_mini_program_template_releases/:id'
    },
    // 小程序模板应用小程序列表
    detail: {
        method: 'get',
        url: '/ant_mini_program_templates/:id/ant_mini_programs'
    },
    // 小程序模板提审小程序
    auditApply: {
        method: 'post',
        url: '/ant_mini_program_templates/:id/audit_apply'
    },
}


// WEBPACK FOOTER //
// ./src/api/templates.js